<div class="workers-modal">

  <!-- Header -->
  <div class="row align-items-center">
    <div class="col">
      <h3 class="text-manax m-0 mb-4 d-flex justify-content-between align-items-center">
        <!-- Título a la izquierda -->
        <span class="text-purple-manax text-capitalize title-modal">
          Trabajador
        </span>
        <!-- Botones a la derecha -->
        <span class="d-flex align-items-center">
          <button type="button" class="btn btn-link text-manax mr-4 p-2" (click)="openMovementsModal()"
            *ngIf="worker?._id">
            <i class="material-icons">access_time</i> Fichajes
          </button>
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12 worker-content" [ngClass]="{darken: readOnly}" (click)="setEditable()">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">

        <div class="row pt-1">
          <div class="col-md-5">
            <mat-form-field appearance="outline">
              <mat-label> Nombre </mat-label>
              <input matInput name="firstname" formControlName="firstname" type="text" #firstnameInput
                [readonly]="readOnly" [ngClass]="{ 'is-invalid': submitted && f['firstname'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['firstname']?.errors?.['required']">
              Nombre Obligatorio
            </mat-error>
          </div>
          <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label> Apellido </mat-label>
              <input matInput name="lastname" formControlName="lastname" type="text" #lastnameInput
                [readonly]="readOnly" [ngClass]="{ 'is-invalid': submitted && f['lastname'].errors }">
            </mat-form-field>
            <mat-error *ngIf="submitted && f['lastname']?.errors?.['required']">
              Apellido Obligatorio
            </mat-error>
          </div>
          <div class="col-md-3">
            <mat-form-field appearance="outline">
              <mat-label> Nro. Ident. </mat-label>
              <input matInput name="idn" formControlName="idn" type="text" #idnInput [readonly]="readOnly">
            </mat-form-field>
          </div>
          <!--div class="col-md-4">
            <mat-form-field appearance="outline" >
              <input matInput name="dob" formControlName="dob" placeholder="Fecha Nacimiento" type="date" #dobInput
                [readonly]="readOnly">
            </mat-form-field>
          </div-->
        </div>


        <div class="row bg-light">
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12 mb-2">
                <h5>
                  Teléfonos
                  <button *ngIf="!readOnly" type="button" class="btn btn-link text-success ml-2 p-0"
                    (click)="addPhone()">
                    <i class="material-icons small">add</i> agregar
                  </button>
                </h5>
                <div *ngIf="!phones.controls?.length"> - sin teléfonos - </div>
              </div>
            </div>

            <ng-container *ngFor="let p of phones.controls; let i=index">
              <div formArrayName="phones">
                <div [formGroupName]="i">

                  <div class="row">
                    <!--div class="col-md-4 pr-md-1">
                      <mat-form-field appearance="outline" >
                        <input matInput [readonly]="readOnly" type="text" name="type" formControlName="type"
                          placeholder="Tipo">
                      </mat-form-field>
                    </div-->

                    <div class="col-md-8">
                      <mat-form-field appearance="outline">
                        <mat-label> Número </mat-label>
                        <input matInput [readonly]="readOnly" type="number" name="number" formControlName="number">
                      </mat-form-field>
                    </div>

                    <div class="col-md-4 pl-md-1">
                      <button *ngIf="!readOnly" type="button" class="btn btn-link text-danger m-0 mt-3 ml-0 p-0 small"
                        (click)="removePhone(i)">quitar
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </ng-container>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-12 mb-2">
                <h5>
                  Correos electrónicos
                  <button *ngIf="!readOnly" type="button" class="btn btn-link text-success ml-2 p-0"
                    (click)="addEmail()">
                    <i class="material-icons small">add</i> agregar
                  </button>
                </h5>
                <div *ngIf="!emails.controls?.length"> - sin correos - </div>
              </div>
            </div>

            <ng-container *ngFor="let p of emails.controls; let i=index">
              <div formArrayName="emails">
                <div [formGroupName]="i">

                  <div class="row">
                    <!--div class="col-md-4 pr-md-0">
                      <mat-form-field appearance="outline" >
                        <input matInput [readonly]="readOnly" type="text" name="type" formControlName="type"
                          placeholder="Tipo">
                      </mat-form-field>
                    </div-->

                    <div class="col-md-8">
                      <mat-form-field appearance="outline">
                        <mat-label> Email </mat-label>
                        <input matInput [readonly]="readOnly" type="text" name="address" formControlName="address">
                      </mat-form-field>
                    </div>

                    <div class="col-md-4 pl-md-0">
                      <button *ngIf="!readOnly" type="button" class="btn btn-link text-danger m-0 mt-3 ml-0 p-0 small"
                        (click)="removeEmail(i)">quitar
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="col-md-6" *ngIf="!this.worker._id">
          <label>
            ¿Crear usuario para la aplicación móvil? <br>
            <input type="checkbox" [(ngModel)]="createUser" name="createUser" value="true" />
          </label>
        </div>

        <div class="col-md-12" *ngIf="createUser && !this.worker._id">
          <div class="row">
            <div class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label> Nombre de usuario </mat-label>
                <input matInput name="username" formControlName="username" type="text" #usernameInput
                  [readonly]="readOnly" [ngClass]="{ 'is-invalid': submitted && f['username'].errors && createUser }">
              </mat-form-field>
              <mat-error *ngIf="submitted && f['username']?.errors?.['required'] && createUser">
                Nombre de usuario requerido
              </mat-error>
            </div>
            <div class="col-md-6">
              <mat-form-field appearance="outline">
                <mat-label> Contraseña </mat-label>
                <input matInput name="password" formControlName="password" type="text" #passwordInput
                  [readonly]="readOnly" [ngClass]="{ 'is-invalid': submitted && f['password'].errors && createUser }">
              </mat-form-field>
              <mat-error *ngIf="submitted && f['password']?.errors?.['required'] && createUser">
                Contraseña requerida
              </mat-error>
            </div>
          </div>
        </div>
        <div class="row mt-3" *ngIf="worker._id && isDev">
          <div class="col-3">
            <label>
              Borrada? <br>
              <input name="isDeleted" formControlName="isDeleted" type="checkbox" [disabled]="readOnly">
            </label>
          </div>
          <div class="col-5">
            <mat-form-field appearance="outline">
              <input matInput placeholder="Id" type="text" [value]="worker._id" readonly>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-12 pt-4">
            <!--button mat-raised-button type="button" class="m-0 ml-1 mb-2 pull-left btn btn-light"
              (click)="openMovementsModal()" *ngIf="worker?._id">
              Marcaciones
            </button-->
            <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax"
              *ngIf="!readOnly">
              <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
              Guardar
            </button>
            <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link" (click)="cancelSubmit(); "
              *ngIf="!readOnly">
              Cancelar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>